<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <orgsidebar></orgsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div v-if="wtdata!==null" class="moduleCard">
            <wondertable :wtID="'orgOrderHistory'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="'No orders found found'" :defaultDirection="1"
                         :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Order History'" :burgerMenu="burgermenu" ref="thisWT"></wondertable>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>

  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import orgsidebar from "../../layout/Organization/Sidebar.vue"
  import wondertable from "../../components/WonderTable.vue"

  export default {
    name: 'OrgOrderHistory',
    components: {acheader,acfooter,orgsidebar,wondertable},
    data() {
      return {
        burgermenu:[],
        wids: ["OrderID"],
        wtdata: null,
        wtmethods: {
          doViewDetails: { method: function(param, ref) {
            ref.doViewDetails(param);
          }, ref: this}
        }
      }
    },
    methods: {
      doViewDetails(param) {
         window.open(this.$hostname+"/Streamable.svc/GetOrderPDF?OrderID="+param.OrderID);
      },
      renderTable() {
        this.apiCommand([
       {
         Operation: "Organization",
         Function: "GetOrderHistory",
         Fields: {
           OrganizationID: this.$route.params.id
         }
       }      
        ]).then(response=>{
          try {
            var cr = JSON.parse(response.CommandResult);
            this.wtdata = JSON.parse(cr.returnObjects[0].returnObject);

          }
          catch(e) {
            this.popDialog(1, "An unspecified error occurred");
          }

        })
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapOrg(this.$route.params.id);
        this.renderTable();
      });
    }
  }
</script>
